import React from "react";
import GridItem from "../../../../Components//UiComponents/GridItem/GridItem";
import DMSHeader from "../../DMSHeader/DMSHeader";
import { useLocation } from "react-router-dom";
import UserRegistrationForm from "./UserRegistrationForm";
import { useTranslation } from "react-i18next";

// Functional component for creating/editing a user
const CreateUser = () => {
  const { t } = useTranslation(); // Initialize translation function

  const { state } = useLocation(); // Get location state from router
  let edit = state?.edit; // Check if 'edit' mode is enabled

  // Layout configuration for the grid items
  const layoutData = [
    {
      x: 0,
      y: 0,
      width: 12,
      height: 1,
      id: 1,
      // Render header with dynamic title based on edit/create mode
      component: (
        <DMSHeader
          title={
            edit
              ? t("Edit User Details")
              : t("createuser_management_formheader")
          }
          showIconsForback={true}
        />
      ),
    },
    {
      x: 0,
      y: 1,
      width: 12,
      height: 15,
      id: 2,
      // Render the user registration form
      component: <UserRegistrationForm />,
    },
  ];

  // Render grid with the specified layout
  return (
    <div className="grid-stack grid-stack-instance-1 ">
      <GridItem layoutData={layoutData} />
    </div>
  );
};

export default CreateUser; // Export the component
